'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var TOKEN_KEY = 'token';
var EXPIRES_AT_KEY = 'expiresAt';

var getExpiresAt = exports.getExpiresAt = function getExpiresAt() {
  return Number(window.localStorage.getItem(EXPIRES_AT_KEY)) || null;
};

var hasToken = exports.hasToken = function hasToken() {
  return getToken() !== null;
};

var getToken = exports.getToken = function getToken() {
  var expiresAt = getExpiresAt();
  if (expiresAt === null || expiresAt > Date.now()) {
    return window.localStorage.getItem(TOKEN_KEY) || null;
  }
  return null;
};

var setToken = exports.setToken = function setToken(token, expiresAt) {
  window.localStorage.setItem(TOKEN_KEY, token);
  if (expiresAt !== null) {
    window.localStorage.setItem(EXPIRES_AT_KEY, expiresAt);
  } else {
    window.localStorage.removeItem(EXPIRES_AT_KEY);
  }
};

var removeToken = exports.removeToken = function removeToken() {
  window.localStorage.removeItem(TOKEN_KEY);
  window.localStorage.removeItem(EXPIRES_AT_KEY);
};


//////////////////
// WEBPACK FOOTER
// ../~/redux-implicit-oauth2/lib/util/token.js
// module id = 374
// module chunks = 0